import { render } from "./menu.vue?vue&type=template&id=f5233530&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=f5233530&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f5233530"

export default script